import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { NavBar, Space, Button, Radio, Card, Input, Toast, Selector, Popup } from 'antd-mobile';
import './MobileAddMatch.css';
// import axios from 'axios'; // 未使用，已注释
// import { apiHostname } from '../config'; // 未使用，已注释
import { getZoneApi } from '../api';

/**
 * 移动端添加比赛页面
 * 支持选择比赛类型、选手和记录比分
 * 
 * @returns {JSX.Element} 移动端添加比赛页面
 */
const MobileAddMatch = () => {
  // 从URL参数或sessionStorage获取eventId和zone
  const params = useParams();
  const eventId = params.eventId || sessionStorage.getItem('currentEventId');
  const zone = params.zone || sessionStorage.getItem('currentZone');
  
  const navigate = useNavigate();
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [team1Visible, setTeam1Visible] = useState(false);
  const [team2Visible, setTeam2Visible] = useState(false);
  const team1ScoreInputRef = useRef(null);
  const team2ScoreInputRef = useRef(null);
  const [formData, setFormData] = useState({
    type: 'SINGLES', 
    team1: [],
    team2: [],
    scores: [{ team1Score: 0, team2Score: 0 }],
  });

  // 确保必要参数存在
  useEffect(() => {
    if (!eventId || !zone) {
      console.error('缺少必要参数 eventId或zone');
      navigate('/badminton');
      return;
    }
    console.log('[DEBUG] 添加比赛 - 使用参数:', {eventId, zone});
  }, [eventId, zone, navigate]);

  // 获取球员列表
  useEffect(() => {
    const fetchPlayers = async () => {
      try {
        setLoading(true);
        const zoneApi = getZoneApi(zone);
        const response = await zoneApi.players.getAll();
        if (response.success) {
          const playerData = response.data;
          console.log('获取到的球员数据:', playerData);
          
          // 检查球员数据中的ID字段
          if (playerData.length > 0) {
            const samplePlayer = playerData[0];
            console.log('样本球员数据:', samplePlayer);
            console.log('球员ID字段:', {
              id: samplePlayer.id,
              _id: samplePlayer._id
            });
          }
          
          setPlayers(playerData);
        } else {
          throw new Error(response.message || '获取球员数据失败');
        }
        setLoading(false);
      } catch (err) {
        setError('获取球员数据失败');
        setLoading(false);
        console.error('获取球员数据失败:', err);
      }
    };

    if (zone) {
      fetchPlayers();
    }
  }, [zone]);

  const handleTypeChange = (type) => {
    setFormData(prev => ({
      ...prev,
      type,
      team1: [],
      team2: []
    }));
  };

  const handleTeam1Select = (selectedIds) => {
    const maxPlayers = formData.type === 'SINGLES' ? 1 : 2;
    // 限制选择数量
    if (selectedIds.length > maxPlayers) {
      Toast.show({
        content: `${formData.type === 'SINGLES' ? '单打' : '双打'}最多选择${maxPlayers}名选手`,
        position: 'center',
      });
      return;
    }
    
    console.log('选择队伍1球员:', selectedIds);
    console.log('所有球员数据:', players);
    
    // 检查是否已在队伍2中
    const hasConflict = selectedIds.some(id => 
      formData.team2.some(player => player.id === id || player._id === id)
    );
    
    if (hasConflict) {
      Toast.show({
        content: '选手已在另一队伍中',
        position: 'center',
      });
      return;
    }

    // 确保只选择与selectedIds匹配的球员
    const selectedPlayers = players.filter(player => {
      // 球员ID可能存储在id或_id字段中
      const playerId = player.id || player._id;
      return selectedIds.includes(playerId);
    });
    
    console.log('选中的队伍1球员:', selectedPlayers);
    
    setFormData(prev => ({
      ...prev,
      team1: selectedPlayers
    }));
  };

  const handleTeam2Select = (selectedIds) => {
    const maxPlayers = formData.type === 'SINGLES' ? 1 : 2;
    // 限制选择数量
    if (selectedIds.length > maxPlayers) {
      Toast.show({
        content: `${formData.type === 'SINGLES' ? '单打' : '双打'}最多选择${maxPlayers}名选手`,
        position: 'center',
      });
      return;
    }
    
    console.log('选择队伍2球员:', selectedIds);
    
    // 检查是否已在队伍1中
    const hasConflict = selectedIds.some(id => 
      formData.team1.some(player => player.id === id || player._id === id)
    );
    
    if (hasConflict) {
      Toast.show({
        content: '选手已在另一队伍中',
        position: 'center',
      });
      return;
    }

    // 确保只选择与selectedIds匹配的球员
    const selectedPlayers = players.filter(player => {
      // 球员ID可能存储在id或_id字段中
      const playerId = player.id || player._id;
      return selectedIds.includes(playerId);
    });
    
    console.log('选中的队伍2球员:', selectedPlayers);
    
    setFormData(prev => ({
      ...prev,
      team2: selectedPlayers
    }));
  };

  const handleScoreChange = (team, value) => {
    const scoreKey = `${team}Score`;
    const newValue = parseInt(value, 10) || 0;
    
    setFormData(prev => ({
      ...prev,
      scores: [{ ...prev.scores[0], [scoreKey]: newValue }]
    }));
  };

  // 选中输入框中的所有文本
  const selectAllText = (ref, e) => {
    setTimeout(() => {
      let input = null;
      // 尝试从 ref 获取 input 元素
      if (ref?.current) {
        input = ref.current.nativeElement || 
                ref.current.inputRef?.current ||
                ref.current;
      }
      // 如果 ref 不可用，尝试从事件目标获取
      if (!input && e?.target) {
        input = e.target.querySelector('input') || e.target;
      }
      // 选中文本
      if (input) {
        if (typeof input.select === 'function') {
          input.select();
        } else if (input.setSelectionRange) {
          input.setSelectionRange(0, input.value.length);
        }
      }
    }, 10);
  };

  const handleSubmit = async () => {
    try {
      // 验证选手数量
      const requiredPlayers = formData.type === 'SINGLES' ? 1 : 2;
      if (formData.team1.length < requiredPlayers || formData.team2.length < requiredPlayers) {
        Toast.show({
          content: '请选择完整的队伍',
          position: 'center',
        });
        return;
      }

      // 验证比分
      if (formData.scores[0].team1Score === 0 && formData.scores[0].team2Score === 0) {
        Toast.show({
          content: '请填写比分',
          position: 'center',
        });
        return;
      }

      // 准备提交数据
      const matchData = {
        type: formData.type,
        teams: {
          team1: formData.team1.map(player => ({
            player: player.id || player._id
          })),
          team2: formData.team2.map(player => ({
            player: player.id || player._id
          }))
        },
        scores: `${formData.scores[0].team1Score}-${formData.scores[0].team2Score}`
      };

      console.log('[DEBUG] 准备提交的比赛数据:', {
        eventId,
        zone,
        matchData
      });

      // 发送请求创建比赛
      const zoneApi = getZoneApi(zone);
      console.log('[DEBUG] 创建的API客户端:', {
        zone
      });

      // 使用zone参数创建比赛
      const response = await zoneApi.events.addMatch(eventId, matchData);
      
      console.log('[DEBUG] 服务器响应:', response);

      if (response.success) {
        Toast.show({
          icon: 'success',
          content: '添加成功',
          afterClose: () => {
            navigate(`/badminton/${zone}/events/${eventId}`);
          },
        });
      } else {
        throw new Error(response.message || '创建比赛失败');
      }
    } catch (err) {
      console.error('[DEBUG] 创建比赛失败，详细错误:', {
        message: err.message,
        response: err.response?.data,
        status: err.response?.status,
        config: err.config
      });

      Toast.show({
        icon: 'fail',
        content: err.response?.data?.message || err.message || '创建比赛失败',
      });
    }
  };

  if (loading) {
    return <div className="adm-dot-loading">加载中...</div>;
  }

  if (error) {
    return <div className="adm-error-block">{error}</div>;
  }

  return (
    <div className="mobile-add-match">
      <NavBar onBack={() => navigate(`/badminton/${zone}/events/${eventId}`)}>添加比赛</NavBar>
      
      <div className="mobile-add-match-content">
        {/* 比赛类型选择 */}
        <Card>
          <Radio.Group 
            value={formData.type}
            onChange={handleTypeChange}
          >
            <Space justify="around" block>
              <Radio value="SINGLES">单打</Radio>
              <Radio value="DOUBLES">双打</Radio>
            </Space>
          </Radio.Group>
        </Card>

        {/* 选手选择 */}
        <Card title="选择选手">
          <div className="mobile-add-match-teams">
            <div className="mobile-add-match-team">
              <Button
                block
                fill="outline"
                onClick={() => setTeam1Visible(true)}
              >
                {formData.team1.length > 0 ? (
                  <Space wrap>
                    {formData.team1.map(player => {
                      const playerId = player.id || player._id;
                      return (
                        <span key={playerId} className="mobile-selected-player">
                          {player.name}
                          <span className="mobile-player-level">[{player.level || '新手'}]</span>
                        </span>
                      );
                    })}
                  </Space>
                ) : (
                  '选择队伍1选手'
                )}
              </Button>
            </div>
            
            <div className="mobile-add-match-team">
              <Button
                block
                fill="outline"
                onClick={() => setTeam2Visible(true)}
              >
                {formData.team2.length > 0 ? (
                  <Space wrap>
                    {formData.team2.map(player => {
                      const playerId = player.id || player._id;
                      return (
                        <span key={playerId} className="mobile-selected-player">
                          {player.name}
                          <span className="mobile-player-level">[{player.level || '新手'}]</span>
                        </span>
                      );
                    })}
                  </Space>
                ) : (
                  '选择队伍2选手'
                )}
              </Button>
            </div>
          </div>
        </Card>

        {/* 比分记录 */}
        <Card title="记录比分">
          <div className="mobile-add-match-score-inputs">
            <div className="mobile-add-match-score-team">
              <Input
                ref={team1ScoreInputRef}
                type="number"
                placeholder="队伍 1 比分"
                value={formData.scores[0].team1Score}
                onChange={val => handleScoreChange('team1', val)}
                onFocus={(e) => {
                  selectAllText(team1ScoreInputRef, e);
                  // 延迟滚动，确保输入框完全可见
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }, 300);
                }}
                onClick={(e) => selectAllText(team1ScoreInputRef, e)}
              />
            </div>
            <div className="mobile-add-match-score-team">
              <Input
                ref={team2ScoreInputRef}
                type="number"
                placeholder="队伍 2 比分"
                value={formData.scores[0].team2Score}
                onChange={val => handleScoreChange('team2', val)}
                onFocus={(e) => {
                  selectAllText(team2ScoreInputRef, e);
                  // 延迟滚动，确保输入框完全可见
                  setTimeout(() => {
                    e.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }, 300);
                }}
                onClick={(e) => selectAllText(team2ScoreInputRef, e)}
              />
            </div>
          </div>
        </Card>
      </div>
      
      <div className="mobile-add-match-actions">
        <Button 
          block 
          color="primary"
          size="large"
          onClick={handleSubmit}
        >
          提交
        </Button>
      </div>

      {/* 队伍1选手选择弹窗 */}
      <Popup
        visible={team1Visible}
        onMaskClick={() => setTeam1Visible(false)}
        position="bottom"
        bodyStyle={{ height: '60vh' }}
      >
        <div className="mobile-player-selector">
          <div className="mobile-player-selector-header">
            <span>选择队伍1选手</span>
            <Button
              fill="none"
              onClick={() => setTeam1Visible(false)}
            >
              完成
            </Button>
          </div>
          <Selector
            columns={3}
            options={players.map((player, index) => {
              // 球员ID可能存储在id或_id字段中
              const playerId = player.id || player._id || `player-${index}`;
              return {
                label: (
                  <div key={playerId} className="mobile-player-option">
                    <span>{player.name}</span>
                    <span className="mobile-player-level">[{player.level || '新手'}]</span>
                  </div>
                ),
                value: playerId
              };
            })}
            value={formData.team1.map(p => p.id || p._id)}
            onChange={handleTeam1Select}
            multiple={true}
          />
        </div>
      </Popup>

      {/* 队伍2选手选择弹窗 */}
      <Popup
        visible={team2Visible}
        onMaskClick={() => setTeam2Visible(false)}
        position="bottom"
        bodyStyle={{ height: '60vh' }}
      >
        <div className="mobile-player-selector">
          <div className="mobile-player-selector-header">
            <span>选择队伍2选手</span>
            <Button
              fill="none"
              onClick={() => setTeam2Visible(false)}
            >
              完成
            </Button>
          </div>
          <Selector
            columns={3}
            options={players.map((player, index) => {
              // 球员ID可能存储在id或_id字段中
              const playerId = player.id || player._id || `player-${index}`;
              return {
                label: (
                  <div key={playerId} className="mobile-player-option">
                    <span>{player.name}</span>
                    <span className="mobile-player-level">[{player.level || '新手'}]</span>
                  </div>
                ),
                value: playerId
              };
            })}
            value={formData.team2.map(p => p.id || p._id)}
            onChange={handleTeam2Select}
            multiple={true}
          />
        </div>
      </Popup>
    </div>
  );
};

export default MobileAddMatch; 